import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import isEqual from 'lodash/isEqual';
import noop from 'lodash/noop';
import get from 'lodash/get';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Menu from 'yoda-core-components/lib/assets/svg/Menu.svg';
import MenuIconNew from 'yoda-core-components/lib/assets/svg/MenuIconNew.svg';
import IrisHamburgerLazy from '../IrisHamburger/HeaderChunksAndFooterLazy';
import * as styles from './HamburgerPlaceHolder.css';

const cx = classNames.bind(styles);

export class HamburgerPlaceHolder extends Component {
    static propTypes = {
        customIcon: PropTypes.node,
        automationId: PropTypes.string,
        enableHamburgerMenuLabel: PropTypes.bool,
        headerOverlayRef: PropTypes.object,
        checkoutProps: PropTypes.object,
        displayHamburgerSlider: PropTypes.func,
        HamburgerSlider: PropTypes.bool,
    };

    static defaultProps = {
        customIcon: '',
        automationId: '',
        enableHamburgerMenuLabel: false,
        headerOverlayRef: {},
        checkoutProps: {},
        displayHamburgerSlider: noop,
        HamburgerSlider: false,
    };

    state = {
        slideOpen: get(this.props, 'HamburgerSlider.isHamburgerSliderOpen', false),
        title: 'MENU',
    };

    /* ugly code need to redo in r2 */
    shouldComponentUpdate(nextProps, nextState) {
        if (isEqual(nextProps, this.props) && isEqual(nextState, this.state)) {
            return false;
        }
        return true;
    }

    componentDidUpdate(prevProps) {
        const {
            HamburgerSlider: { isHamburgerSliderOpen: prevIsSliderOpen },
        } = prevProps;
        const {
            HamburgerSlider: { isHamburgerSliderOpen: isSliderOpen },
        } = this.props;
        const { slideOpen } = this.state;
        /** when slider is closed externally - remove the styling */
        if (prevIsSliderOpen && !isSliderOpen && slideOpen) {
            this.setState({ slideOpen: false });
            this.addOrRemoveStyling(false);
        }
    }

    addOrRemoveStyling = (menuOpenStatus) => {
        const root = document.getElementsByTagName('html')[0];
        if (menuOpenStatus) {
            root.classList.add('blockContentScroll', 'scrollBlock', 'hamburgerScrollBlock');
            this.props.headerOverlayRef.current.style.display = 'block';
        } else {
            root.classList.remove('blockContentScroll', 'scrollBlock', 'hamburgerScrollBlock');
            this.props.headerOverlayRef.current.style.display = 'none';
        }
    };

    /** *
     * Slider-scrollLock, copied from old yoda Hamburger menu to make menu fit in the layout
     */
    toggleSlideState = (menuOpenStatus) => {
        this.addOrRemoveStyling(menuOpenStatus);
        this.setState({
            slideOpen: menuOpenStatus,
        });
        this.props.displayHamburgerSlider(menuOpenStatus);
    };

    toggleMenu = () => {
        this.toggleSlideState(!this.state.slideOpen);
    };

    render() {
        const { customIcon, automationId, enableHamburgerMenuLabel, checkoutProps } = this.props;
        const { isHamburgerSliderOpen: slideOpen } = this.props.HamburgerSlider;

        const HamburgerMenuIcon = enableHamburgerMenuLabel ? (
            <span>
                <Icon
                    iconType="svg"
                    automationId="test-automation-icon"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    pathClassName={styles.hamburgerIcon}
                >
                    <MenuIconNew />
                </Icon>
            </span>
        ) : (
            <Icon
                iconType="svg"
                automationId="test-automation-icon"
                width="32px"
                height="32px"
                viewBox="0 0 32 32"
                pathClassName={styles.hamburgerIcon}
            >
                <Menu />
            </Icon>
        );

        const toggleMenu = this.props.customIcon ? (
            <button onClick={this.toggleMenu}>{customIcon}</button>
        ) : (
            <button
                data-automation-id="jcp-menu"
                className={styles.menuLink}
                onClick={this.toggleMenu}
            >
                {HamburgerMenuIcon}
            </button>
        );

        return (
            <div
                className={cx('sliderWrapper', 'newHamburgerPlaceHolder')}
                data-automation-id={automationId}
            >
                <div className={styles.iconWrapper} data-automation-id="button-menu">
                    {toggleMenu}
                </div>
                <IrisHamburgerLazy
                    enableHamburgerMenuLabel={enableHamburgerMenuLabel}
                    slideOpen={slideOpen}
                    toggleSlideState={this.toggleSlideState}
                    checkoutProps={checkoutProps}
                />
            </div>
        );
    }
}

export default HamburgerPlaceHolder;
